/* vm-worldmap-zoom.js — Pinch/Drag/Wheel Zoom für Verbreitungs-Karte (Sprint 9C rev 2, 2026-05-18) */
(function () {
  'use strict';
  function init() {
    var zoomables = document.querySelectorAll('.vm-worldmap__zoomable');
    zoomables.forEach(setup);
  }
  function setup(container) {
    var transform = container.querySelector('.vm-worldmap__transform');
    if (!transform) return;
    var state = { scale: 1, x: 0, y: 0, minScale: 1, maxScale: 4 };
    var pointers = new Map();
    var lastDist = 0;
    var lastMid = null;
    var isDragging = false;
    var dragStart = null;
    var lastInteraction = 0;

    function apply() {
      transform.style.transform = 'translate3d(' + state.x + 'px,' + state.y + 'px,0) scale(' + state.scale + ')';
      if (Date.now() - lastInteraction < 500) container.classList.add('is-interacted');
    }
    function clamp() {
      var rect = container.getBoundingClientRect();
      var contentW = rect.width * state.scale;
      var contentH = rect.height * state.scale;
      var maxX = 0;
      var minX = rect.width - contentW;
      var maxY = 0;
      var minY = rect.height - contentH;
      if (contentW <= rect.width) { state.x = (rect.width - contentW) / 2; } else {
        if (state.x > maxX) state.x = maxX;
        if (state.x < minX) state.x = minX;
      }
      if (contentH <= rect.height) { state.y = (rect.height - contentH) / 2; } else {
        if (state.y > maxY) state.y = maxY;
        if (state.y < minY) state.y = minY;
      }
    }
    function zoomAt(scaleMultiplier, cx, cy) {
      var rect = container.getBoundingClientRect();
      var px = cx - rect.left;
      var py = cy - rect.top;
      var newScale = state.scale * scaleMultiplier;
      if (newScale < state.minScale) newScale = state.minScale;
      if (newScale > state.maxScale) newScale = state.maxScale;
      var ratio = newScale / state.scale;
      state.x = px - (px - state.x) * ratio;
      state.y = py - (py - state.y) * ratio;
      state.scale = newScale;
      lastInteraction = Date.now();
      clamp();
      apply();
    }
    function resetZoom() { state.scale = 1; state.x = 0; state.y = 0; apply(); }

    container.addEventListener('pointerdown', function (e) {
      container.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      lastInteraction = Date.now();
      if (pointers.size === 1) {
        isDragging = true;
        dragStart = { x: e.clientX, y: e.clientY, sx: state.x, sy: state.y };
      } else if (pointers.size === 2) {
        isDragging = false;
        var pts = Array.from(pointers.values());
        lastDist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        lastMid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
      }
      e.preventDefault();
    });
    container.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 1 && isDragging && dragStart) {
        state.x = dragStart.sx + (e.clientX - dragStart.x);
        state.y = dragStart.sy + (e.clientY - dragStart.y);
        lastInteraction = Date.now();
        clamp();
        apply();
      } else if (pointers.size === 2 && lastMid) {
        var pts = Array.from(pointers.values());
        var dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        var mid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
        if (lastDist > 0) {
          var mult = dist / lastDist;
          zoomAt(mult, mid.x, mid.y);
        }
        lastDist = dist;
        lastMid = mid;
      }
      e.preventDefault();
    });
    function endPointer(e) {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) { lastDist = 0; lastMid = null; }
      if (pointers.size === 0) { isDragging = false; dragStart = null; }
      e.preventDefault();
    }
    container.addEventListener('pointerup', endPointer);
    container.addEventListener('pointercancel', endPointer);
    container.addEventListener('pointerleave', endPointer);

    container.addEventListener('wheel', function (e) {
      e.preventDefault();
      var mult = e.deltaY < 0 ? 1.1 : 0.9;
      zoomAt(mult, e.clientX, e.clientY);
    }, { passive: false });

    var lastTap = 0;
    container.addEventListener('click', function (e) {
      var now = Date.now();
      if (now - lastTap < 350) { /* double-tap */
        if (state.scale > 1.1) resetZoom();
        else zoomAt(2, e.clientX, e.clientY);
      }
      lastTap = now;
    });

    var zoomInBtn = container.querySelector('[data-zoom-in]');
    var zoomOutBtn = container.querySelector('[data-zoom-out]');
    var zoomResetBtn = container.querySelector('[data-zoom-reset]');
    if (zoomInBtn) zoomInBtn.addEventListener('click', function () { var r = container.getBoundingClientRect(); zoomAt(1.4, r.left + r.width/2, r.top + r.height/2); });
    if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { var r = container.getBoundingClientRect(); zoomAt(0.7, r.left + r.width/2, r.top + r.height/2); });
    if (zoomResetBtn) zoomResetBtn.addEventListener('click', resetZoom);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
